// Email-harvest hardening (D-08): the address never appears contiguous in source.
// Each contact link carries split `data-user` + `data-domain` attributes; we assemble
// the `mailto:` href at runtime so static HTML holds no scrapable plaintext address.
// Progressive enhancement: without JS the link keeps its human-prompt text (e.g. "email",
// "Start a conversation") and simply doesn't navigate — no address ever leaks.
export default function mailtoLinks() {
    var links = document.querySelectorAll("[data-user][data-domain]");
    links.forEach(function (el) {
        var addr = el.dataset.user + "@" + el.dataset.domain;
        el.setAttribute("href", "mailto:" + addr);
        if (!el.textContent.trim()) el.textContent = addr; // only fill if empty
    });
}
